enum RfpMode {
  ARCH = 'arch',
  LIST = 'list',
}

export default RfpMode;
